<button class="color-settings" [ngClass]="{ 'color-settings--active': isColorSettingsOpen }" (click)="openSettings()">
  <img [src]="'assets/images/button-icons/settings-icon.svg' | bmAssetUrl" alt="color settings icon" />
</button>
